
define('template!sdcNamed',[''],function(template){return '<label class="implicit" ng-transclude>\r\n</label>';});

